export default {
  SET_SERVICE_CONFIG: '@AUTH_GATEWAY/CONFIG/SET_SERVICE_CONFIG',
};
